"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.msalCommon = void 0;
const tslib_1 = require("tslib");
const msalCommon = tslib_1.__importStar(require("@azure/msal-node"));
exports.msalCommon = msalCommon;
//# sourceMappingURL=msal.js.map